import { createFileRoute, Outlet } from '@tanstack/react-router';

import { buildRouteExport } from '~/utils/buildRouteExport';
import { createProtectedRoute } from '~/utils/routeProtection';

import { routeParams } from './-routeParams';

export const Route = createFileRoute('/(main)/settings/article-master')({
  beforeLoad: createProtectedRoute({
    routePath: '/settings/article-master',
    ...routeParams,
  }),
  component: Outlet,
});

export const ARTICLE_MASTER = buildRouteExport({
  Route,
  ...routeParams,
});
